import { render, staticRenderFns } from "./addContractPartya.vue?vue&type=template&id=ecc99ad6"
import script from "./addContractPartya.vue?vue&type=script&lang=js"
export * from "./addContractPartya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports